import { recordQcChecklistChecks } from "@/lib/manufacturing/builderAssistantChecklistClient";

export type PendingQcCheck = {
  result: "pass" | "fail" | "na";
  note: string;
};

export async function flushQcChecklistChecks(
  sessionId: string,
  pending: Record<string, PendingQcCheck>,
): Promise<{ ok: true; saved: { item_id: string; observation_id: string | null }[] } | { ok: false; error: string }> {
  const entries = Object.entries(pending);
  if (entries.length === 0) return { ok: true, saved: [] };
  const saved = await recordQcChecklistChecks(
    sessionId,
    entries.map(([itemId, mark]) => ({ item_id: itemId, result: mark.result, note: mark.note })),
  );
  if (!saved.ok) return saved;
  return { ok: true, saved: saved.data.saved };
}
